import React from "react";

function Cabecalho({ linkImg }) {
  return (
    <img
      src={`${process.env.REACT_APP_BACKEND_LINK}/${linkImg}`}
      alt=""
      style={{ width: "100%", height: "auto" }}
    />
  );
}

export default Cabecalho;
